import { render, staticRenderFns } from "./createAssetStatus.vue?vue&type=template&id=5272aae0&scoped=true"
import script from "./createAssetStatus.vue?vue&type=script&lang=js"
export * from "./createAssetStatus.vue?vue&type=script&lang=js"
import style0 from "./createAssetStatus.vue?vue&type=style&index=0&id=5272aae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272aae0",
  null
  
)

export default component.exports